<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="ch00_fm02"></a><a id="page_vi"></a>B<span class="small">OOKS BY</span> J<span class="small">ERZY</span> K<span class="small">OSINSKI</span></h3>
<p class="paraspaceabove"><strong><span class="small">NOVELS</span></strong></p>
<p class="noindent1"><strong>The Painted Bird</strong></p>
<p class="noindent"><strong>Steps</strong></p>
<p class="noindent"><strong>Being There</strong></p>
<p class="noindent"><strong>The Devil Tree</strong></p>
<p class="noindent"><strong>Cockpit</strong></p>
<p class="noindent"><strong>Passion Play</strong></p>
<p class="noindent"><strong>Pinball</strong></p>
<p class="noindent"><strong>The Hermit of 69th Street</strong></p>
<p class="noindent"><strong>Blind Date</strong></p>
<p class="paraspaceabove"><strong><span class="small">ESSAYS</span></strong></p>
<p class="noindent1"><strong>Passing By</strong></p>
<p class="noindent"><strong>Notes of the Author</strong></p>
<p class="noindent"><strong>The Art of the Self</strong></p>
<p class="paraspaceabove"><strong><span class="small">NONFICTION</span></strong></p>
<p class="noindent1"><strong><em>(Under the pen name Joseph Novak)</em></strong></p>
<p class="noindent"><strong>The Future Is Ours, Comrade</strong></p>
<p class="noindent"><strong>No Third Path</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02.vue?5b4bcb1e